import authAxios from 'utils/axios';
import axios from "axios";

export const switchOrg = (data) => {
  const token = localStorage.getItem('serviceToken')
  return axios.post(
    `${import.meta.env.VITE_API_URL2}/api/v1/auth/switchOrg`,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `bearer ${token}`
      }
    });
};

export const switchDB = (v1_token,db_name) => {
  return authAxios.post(
    `/api/v1/auth/switchDB`,
    { db_name, exchange: true, v1_token }
  );
}